import "./Services.style.scss";
import SubHeading from "../SubHeading/SubHeading";
import { serviceCard } from "../../constants/data";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import useTranslate from "../../hooks/useTranslate";

const Services = () => {
  const { translate, language } = useTranslate();
  const navigate = useNavigate();
  const isRTL = language === "fa";

  return (
    <div
      className={`app__services section__padding ${
        isRTL ? "rtl-mode" : "ltr-mode"
      }`}
    >
      <SubHeading
        title={translate("service.title")}
        description={translate("home.services.heading")}
        kind=""
        spoonColor="white"
      />
      <p className="home-services-intro">{translate("home.services.intro")}</p>
      <div className="app__services-steps flex__center">
        <Grid container>
          <div className="service-page__container">
            <div className="service-page__grid1">
              {serviceCard.map((service, index) => (
                <div
                  key={index}
                  className="service-card"
                  onClick={() => navigate(service.href)}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {/* ===== بخش عکس (بالا) ===== */}
                  <div className="service-card__image-wrapper">
                    <img
                      src={service.src}
                      alt={translate(service.title) || service.title}
                      className="service-card__image"
                    />
                    <div className="service-card__image-overlay" />
                  </div>

                  {/* ===== خط طلایی بین عکس و محتوا ===== */}
                  <div className="service-card__gold-line" />

                  {/* ===== بخش محتوا (پایین) ===== */}
                  <div className="service-card__content">
                    {/* آیکون کوچک + تایتل */}
                    <div className="service-card__header">
                      <div className="service-card__icon-wrapper">
                        {service.icon}
                      </div>
                      <h3 className="service-card__title">
                        {translate(service.titleKey) || service.title}
                      </h3>
                    </div>

                    {/* توضیحات */}
                    <p className="service-card__description">
                      {translate(service.descriptionKey, { defaultValue: translate(service.description) })}
                    </p>

                    {/* Arrow */}
                    <div className="service-card__arrow">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="https://www.w3.org/2000/svg"
                      >
                        <path
                          d={
                            isRTL
                              ? "M19 12H5M5 12L11 18M5 12L11 6"
                              : "M5 12H19M19 12L13 18M19 12L13 6"
                          }
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Grid>
      </div>
    </div>
  );
};
export default Services;
